export const LADE_AUSWAHLWERTE_BELEG = "ladeAuswahlwerteBeleg";